module.exports = __webpack_public_path__ + "static/switch-ad81c2ed5b9fff4257fbf22de51f5fed.jpg";